module.exports = __webpack_public_path__ + "81c0f116dff073f67d15ee2fa3e96ae0.svg";